import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {DataEntity} from 'octopus-connect';
import {map, tap} from 'rxjs/operators';

@Component({
    selector: 'app-gamecode-content-viewer-modal',
    templateUrl: './gamecode-content-viewer-modal.component.html',
    standalone: false
})
export class GamecodeContentViewerModalComponent implements OnInit {
    public isLoading = true;
    public text: string;
    public gamecodeTitle: string;
    private gamecodeGranule: DataEntity;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public modalData: { gamecode$: Observable<DataEntity> },
        public selfDialogRef: MatDialogRef<GamecodeContentViewerModalComponent>) {
    }

    ngOnInit(): void {
        this.modalData.gamecode$.pipe(
            tap(gamecodeGranule => {
                this.gamecodeGranule = gamecodeGranule;
                this.text = this.gamecodeGranule.get('reference').activity_content[0].text;
                this.gamecodeTitle = this.gamecodeGranule.get('metadatas').title;
                this.isLoading = false;
            })
        ).subscribe();
    }

    public close(): void {
        this.selfDialogRef.close();
    }
}